
define('text!modules/reporting/campaigns/contextual/templates/panel.html',[],function () { return '<div class="w-panel-body w-report-panel check-radio-forms"></div>\n<div class="loader-holder">\n  <div class="loader-block"></div>\n  <strand-loader class="load-spinner">\n    <label>requesting data</label>\n  </strand-loader>\n</div>\n';});

